import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { activityKeys } from '@/lib/query-keys';
import { activityService } from '@/services/activity.service';
import { useFilters } from '@/composables/shared/useFilters';

const defaultFilters = { page: 1, limit: 20, type: '', sortBy: 'occurredAt', sortOrder: 'desc' as const };

export function useActivities() {
  const queryClient = useQueryClient();
  const filterState = useFilters(defaultFilters);

  const activitiesQuery = useQuery({
    queryKey: activityKeys.list(filterState.filters),
    queryFn: () => activityService.getAll(filterState.filters),
  });

  const createActivity = useMutation({
    mutationFn: (data: Parameters<typeof activityService.create>[0]) => activityService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: activityKeys.all });
      toast.success('Activity logged');
    },
    onError: () => toast.error('Failed to log activity'),
  });

  return {
    activities: activitiesQuery.data?.data ?? [],
    meta: activitiesQuery.data?.meta,
    isLoading: activitiesQuery.isLoading,
    filters: filterState,
    createActivity,
  };
}
